module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA6UlEQVQ4T53UoQ4CMQzG8f85JBKJRCKRSCQSyaPwCCeRSCSSR0AikUgkEkl6uSaj2dqNJadu++Xb1rUD1uN3A660jyWwBR7AuQMOiXEHLg2mYrqkF3ADrP5ALfYCjgLKkMgyQUeUNIedgI+CLWgREyQFa1AXy4EeGmIlMIc+gXlyxnIBw5nZirBbTv/bi9J/RcxLqIv3Jpkk6nPJdIGX0J5ZVUmVQItJsklNnebA0m3KiwqL34JRaYQvKgUjTHfsogrWYiEqYCvmorYfukWb6ZN2+0P72gELoBWzSX/64RR4N3RqO3U2BuILP75RPXORCJ4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/imgages/cha.png
// module id = ToW5
// module chunks = 1